<template>
  <y-wrapper @back="handleBack">
    <template slot="nav">
      <div class="nav-wrap">
        <div class="left">线上继续教育管理</div>
        <div class="right">
          <div class="btn active" @click="ifDialogShow=true">
            创建线上继续教育
          </div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="main-content">
        <div class="search-wrap">
          <div class="left-search">
            <select
              name="status"
              class="select"
              v-model="searchForm.status"
              @change="selecChange"
            >
              <option value="">全部状态</option>
              <option v-for="(item, index) in educationStatus" :key="index" :value="item.value">{{ item.key }}</option>
            </select>
            <select
              name="status"
              class="select"
              v-model="searchForm.level"
              @change="selecChange"
            >
              <option value="">全部级别</option>
              <option v-for="(item, index) in highClassLevelList" :key="index" :value="item.value">{{ item.key }}</option>
            </select>
            <select
              name="status"
              class="select"
              v-model="searchForm.year"
              @change="selecChange"
            >
              <option value="">全部年份</option>
              <option v-for="(item) in yearList"
                :key="item.value"
                :value="item.value">{{ item.value }}年
              </option>
            </select>
          </div>
          <div class="right-search">
            <div class="input-wrap">
              <input
                type="text"
                placeholder="请输入搜索内容"
                v-model.lazy="searchForm.keywords"
                @keyup.enter="inputChange"
              />
              <div
                v-show="searchForm.keywords != ''"
                class="close"
                @click="hideIcon"
              >
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
              <div class="searchBtn" @click="getRequest">搜索</div>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <yioks-loading v-show="isLoading"></yioks-loading>
          <template v-if="!isLoading">
            <template v-if="pageList.length">
              <div>
                <div class="table alter-table">
                  <div class="thead">
                    <div class="tr">
                      <div class="th index">
                        <p>序号</p>
                      </div>
                      <div class="th name">
                        <strong>线上继续教育</strong>
                      </div>
                      <div class="th train_date">
                        <strong>培训日期</strong>
                      </div>
                      <div class="th hours">
                        <strong>学时</strong>
                      </div>
                      <div class="th status">
                        <strong>状态</strong>
                      </div>
                      <div class="th opt"><strong>操作</strong></div>
                    </div>
                  </div>
                  
                  <div class="scrollArea">
                    <vue-scroll :ops="ops" ref="vs">
                      <div class="tbodyWrap">
                        <div class="tbody">
                          <div
                            class="tr"
                            v-for="(item, index) in pageList"
                            :key="index"
                          >
                            <div class="td index">
                              <p>{{ index+1 }}</p>
                            </div>
                            <div class="td name">
                              <p style="text-align:center;" @click="lookOver(item)">
                                <!--  @click="lookOver(item)" -->
                                {{ item.name }}
                              </p>
                            </div>
                            <div class="td train_date">
                              <p>{{ item.start_date | time(false) }}至{{item.end_date | time(false)}}</p>
                            </div>
                            <div class="td hours">
                              <p>{{ item.hours }}</p>
                            </div>
                            <div class="td status">
                              <p>{{ item.status | educationStatusFilter }}</p>
                            </div>
                            <div class="td opt">
                              <span @click="lookOver(item)">查看</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </vue-scroll>
                  </div>
                
                </div>
              </div>
              <div class="paging" id="paging">
                <yioks-paging
                  :paging="paging"
                  @goto-page="gotoPage($event)"
                ></yioks-paging>
              </div>
            </template>
            <template v-else-if="!pageList.length">
              <div class="scrollArea">
                <yioks-empty h="500px"></yioks-empty>
              </div>
            </template>
          </template>
        </div>
        <el-dialog
          :visible.sync="ifDialogShow"
          :close-on-click-modal="false"
          top="13vh"
          width="680px"
          custom-class="create-high-train-dialog"
        >
          <div class="select-level">
            <p class="title">创建线上继续教育</p>
            <div class="radio-wrap">
              <div class="radio-title">级别：</div>
              <el-radio-group v-model="classLevel" class="radio-content">
                <el-radio
                  v-for="(item, index) in highClassLevelList"
                  :label="item.value"
                  :key="index"
                  class="radio-item"
                  border
                >{{item.key}}</el-radio>
              </el-radio-group>
            </div>
            <div class="dia-footer">
              <el-button class="button" type="primary" @click="toCreate">确定</el-button>
              <el-button class="button" type="danger" @click="ifDialogShow=false">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </template>
  </y-wrapper>
</template>

<script>
  import ops from "@/assets/js/vuescrollOption";
  import { getEducationList } from "@/api/education/education";
  import { educationStatusFilter } from '@/assets/js/yioksFilters'
  import { educationStatus,highClassLevelList,enroll_type_list } from "@/assets/js/select";
  
  export default {
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
    },
    
    data() {
      return {
        educationStatus,
        highClassLevelList,
        ifDialogShow: false,
        classLevel:"",
        searchForm: {
          status: "",
          level: "",
          keywords: "",
          year: new Date().getFullYear(),
        },
        enroll_type_list,
        ops: ops(),
        page: 1,
        paging: {
          start: 0, // 每页从第几条数据开始
          prePage: 20, // 一页多少条数据
          total: 0, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true,
        },
        isLoading: false,
        pageList: [],
      };
    },
    
    filters: {
      educationStatusFilter,
    },
    computed: {
      // 获取2019年至今的年份数组
      yearList(){
        let year = new Date().getFullYear();
        let yearList = [];
        for(var i = 0; i <= (year-2019); i++ ){
          yearList.push(
            {value:(2019+i), label:(2019+i)},
          );
        }
        return  yearList;
      }
    },
    created() {
      this.setQuery();
    },
    
    methods: {
      handleBack() {
        this.$router.push("/");
      },
      
      setQuery() {
        const { status,level, keywords, page,year } = this.$route.query;
        if (status)
          this.$set(
            this.searchForm,
            "status",
            status
          );
        if (keywords) this.$set(this.searchForm, "keywords", keywords);
        if (level) this.$set(this.searchForm, "level", level);
        if (year) this.$set(this.searchForm, "year", year);
        if (page) this.page = Number(page);
        this.loadPageList();
      },
      
      // 创建继续教育
      toCreate() {
        if (this.classLevel === ''){
          this.$message.error('线上继续教育级别不能为空')
          return
        }
        this.$router.push({
          path: "education_crate_one",
          query:{
            classLevel:this.classLevel
          }
        })
      },
      // 搜索
      selecChange() {
        this.pageList = []
        this.changeQuery(true)
      },
      
      inputChange() {
        this.pageList = []
        this.changeQuery(true);
      },
      getRequest() {
        this.pageList = []
        this.changeQuery(true);
      },
      hideIcon() {
        this.$set(this.searchForm, "keywords", "");
        this.getRequest();
      },
      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            ...this.searchForm,
            page: this.page,
          },
        });
        this.loadPageList();
      },
      loadPageList() {
        const { keywords, status,level, page } = this.$route.query;
        
        const paramsData = {
          keywords,
          status,
          level,
          page : page || 1,
          year: this.searchForm.year,
        };
        this.isLoading = true;
        getEducationList(paramsData)
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { list, page } = data.result;
          this.pageList = list;
          this.$set(this.paging, "prePage", page.page_size);
          this.$set(this.paging, "total", page.total_row);
          this.$set(
            this.paging,
            "start",
            (this.page - 1) * this.paging.prePage
          );
        })
        .catch((err) => {
          this.isLoading = false;
          console.error("err", err);
        });
      },
      gotoPage(start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
        // this.$refs["vs"].scrollTo({ y: 0 }); // scorll
      },
      lookOver(row) {
        const { edu_id } = row;
        this.$router.push({
          path: "education_detail",
          query: {
            edu_id: edu_id,
          },
        });
      },
      editItem(row) {
        const { edu_id } = row;
        this.$router.push({
          path: 'education_crate_one',
          query: {
            edu_id: edu_id,
          }
        })
        
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  @import '~@/assets/css/yioksPage'
  .nav-wrap
    flex 1
    box-sizing border-box
    padding 0 30px 0 0
    display flex
    justify-content space-between
    align-items center
    font-size $font_size_big
    .right
      font-size $font_size_big
      .btn
        padding 5px 15px
        cursor pointer
        user-select none
        &.active
          background-color $color_suc
        &+.btn
          margin-left 10px
  .main-content
    flex 1 1 auto
    padding-top 25px
    box-sizing border-box
    width 100%
    background-color $block_bg_color_base
    .search-wrap
      display flex
      justify-content space-between
      align-items center
      height 40px
      margin 0 40px
      .left-search
        height 100%
        .select
          width 155px
          height 100%
          padding 0 15px
          font-size $font_size_medium
          color $color_black
          outline none
          margin-right: 10px;
      .right-search
        height 100%
        .input-wrap
          width 290px
          height 100%
          display flex
          justify-content space-between
          align-items center
          position relative
          input
            width 200px
            height 100%
            padding 0 20px
            font-size $font_size_medium
            color $color_black
            outline 0
          .close
            position absolute
            right 100px
            top 10px
            color $color_info
            cursor pointer
      .searchBtn
        width 90px
        height 100%
        display flex
        justify-content center
        align-items center
        font-size 20px
        background-color $color_suc
        cursor pointer
        user-select none
    .create-high-train-dialog {
    .title {
      font-size 18px
    }
    .radio-wrap {
      // display block
      // text-align center
      padding 40px 0
      display flex
    
      .radio-title {
        width 80px
        height 40px
        display: flex
        justify-content: center
        align-items: center
      }
      .radio-content {
        width 560px
        text-indent: 10px
        display: flex
        flex-wrap: wrap
        .radio-item {
          margin-bottom 10px
        }
      }
    }
    .enroll-type{
      padding-top 0
    }
    .dia-footer {
      display block
      text-align center
    }
  }

</style>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  
  .alter-table
    .tbody
      .tr
        height: auto
        min-height: 49px
        .td
          height: inherit
          display: flex
          flex-direction: column
          justify-content: center
          align-items: center
          &.name
            color: $color_suc
            p
              cursor: pointer
              user-select: none
    .index{
      width:5%;
    }
    .name{
      width:40%;
    }
    .train_date{
      width:25%;
    }
    .hours{
      width:5%;
    }
    .status{
      width:15%;
    }
    .opt{
      flex 1
    }
</style>
